import { render, staticRenderFns } from "./transferImageGallery.vue?vue&type=template&id=1bcf5cfa&scoped=true&"
import script from "./transferImageGallery.vue?vue&type=script&lang=ts&"
export * from "./transferImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./transferImageGallery.vue?vue&type=style&index=0&id=1bcf5cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf5cfa",
  null
  
)

export default component.exports